import React, { useEffect } from 'react'
import {KTSVG} from '../../../_metronic/helpers'
import {useSelector} from 'react-redux'
import SVG from 'react-inlinesvg'
import arrowLeft from '../../../_metronic/assets/custom-icons/arrowLeft.svg'
import arrowRight from '../../../_metronic/assets/custom-icons/arrowRight.svg'
import useUtils from './useUtils'
function Tab2({values, handleChange, setFieldValue, errors, touched}) {
  
  const {fetchCourses} = useUtils()

  const courses = useSelector((state) => state.course?.records || [])

  useEffect(()=>{
    fetchCourses(values.categoryId, values.languageId)
  },[values.categoryId, values.languageId])

  const onSelection = (course) => {
    if (!values.courses.includes(course.title)) {
      setFieldValue('courses', [...values.courses, course.title])
      setFieldValue('courseIds', [...values.courseIds, course.id])
    }
  }

  const onRemoveOne = (courseTitle) => {
    const courseIndex = values.courses.indexOf(courseTitle)
    if (courseIndex > -1) {
      const updatedCourse = values.courses.filter((value) => value !== courseTitle)
      setFieldValue('courses', updatedCourse)
      const updatedCourseIds = values.courseIds.filter((_, index) => index !== courseIndex)
      setFieldValue('courseIds', updatedCourseIds)
    }
  }

  const onRemoveAll = () => {
    setFieldValue('courses', [])
    setFieldValue('courseIds', [])
  }

  const onSelectAll = () => {
    const allCourseTitles = courses.map((course) => course.title)
    const allcourseIds = courses.map((course) => course.id)
    setFieldValue('courses', allCourseTitles)
    setFieldValue('courseIds', allcourseIds)
  }

  return (
    <div>
      <div className='d-flex align-items-start justify-content-center gap-10 flex-wrap'>
        <div className='d-flex flex-column gap-5 text-gray-800 fw-bold fs-6'>
          All Courses
          <div
            className='pb-4 shadow-lg rounded-3 overflow-hidden'
            style={{width: '340px', minHeight: '250px'}}
          >
            <div
              className=' d-flex justify-content-center align-items-center'
              style={{background: '#f5f8fa', height: '35px'}}
            >
              <div style={{cursor: 'pointer'}} onClick={onSelectAll}>
                <span className={`svg-icon svg-icon-1 svg-icon-primary`}>
                  <SVG src={arrowRight} className='svg-icon-2 svg-icon-primary' />
                </span>
              </div>
            </div>
            <div className='p-2 pt-7 c-black t-14 d-flex flex-column'>
              <div style={{height: '400px', overflowY: 'auto'}}>
                {courses.map((course, index) => (
                  <div key={index} className='d-flex gap-2'>
                    <div
                      style={{background: '#eff2f5'}}
                      className='mb-5 rounded-circle border border-4 border-white h-20px w-20px'
                    ></div>
                    <div
                      style={{cursor: 'pointer'}}
                      className='text-gray-800  fw-bold fs-6'
                      onClick={() => onSelection(course)}
                    >
                      {course.title}
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>

        <div className='d-flex gap-5 flex-column text-gray-800 fw-bold fs-6'>
          Selected Courses
          <div
            className='pb-4 shadow-lg rounded-3 overflow-hidden'
            style={{width: '340px', minHeight: '250px'}}
          >
            <div
              className=' d-flex justify-content-center align-items-center'
              style={{background: '#f5f8fa', height: '35px'}}
            >
              <div style={{cursor: 'pointer'}} onClick={onRemoveAll}>
                {' '}
                <span className={`svg-icon svg-icon-1 svg-icon-primary`}>
                  <SVG src={arrowLeft} className='svg-icon-2 svg-icon-primary' />
                </span>
              </div>
            </div>
            <div className='p-2 pt-7 c-black t-14 d-flex flex-column '>
              <div style={{height: '400px', overflowY: 'auto'}}>
                {values.courses &&
                  values.courses.map((courseTitle, index) => (
                    <div key={index} className='d-flex gap-2'>
                      <div
                        style={{background: '#eff2f5'}}
                        className='mb-5 rounded-circle border border-4 border-white h-20px w-20px'
                      ></div>
                      <div
                        className='text-gray-800  fw-bold fs-6'
                        style={{cursor: 'pointer'}}
                        onClick={() => onRemoveOne(courseTitle)}
                      >
                        {courseTitle}
                      </div>
                    </div>
                  ))}
              </div>
            </div>
          </div>
          {touched.courseIds && errors.courseIds && (
            <div className='fv-plugins-message-container ms-3'>
              <span role='alert' className='text-danger'>
                {errors.courseIds}
              </span>
            </div>
          )}
        </div>
      </div>
    </div>
  )
}

export default Tab2
